import { render, staticRenderFns } from "./UiCallout.vue?vue&type=template&id=855f497e&"
import script from "./UiCallout.vue?vue&type=script&lang=js&"
export * from "./UiCallout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports